import {
  exportTableToPdf,
  exportToExcel,
} from "./exportToExcel";
import {
  PrePickingClientInfo,
  PrePickingShortageRow,
} from "types";

export const exportPrePickingShortageReportToExcel = (
  client: PrePickingClientInfo,
  report: PrePickingShortageRow[],
) => {
  exportToExcel({
    data: report,
    columns: {
      Codigo: (item) => item.codigo,
      Descripcion: (item) => item.descripcion,
      Solicitado: (item) => item.solicitado,
      Existencia: (item) => item.existencia,
      Diferencia: (item) => item.diferencia,
    },
    sheetName: "PrePicking",
    fileNamePrefix: `PrePicking_${client.code}`,
    headerRows: [["Cliente", `${client.code} - ${client.razon_social}`], []],
  });
};

export const exportPrePickingShortageReportToPdf = (
  client: PrePickingClientInfo,
  report: PrePickingShortageRow[],
) => {
  exportTableToPdf({
    data: report,
    title: "Reporte de faltantes de Pre-Picking",
    subtitle: `Cliente: ${client.code} - ${client.razon_social}`,
    fileNamePrefix: `PrePicking_${client.code}`,
    columns: [
      { header: "Codigo", value: (item) => item.codigo },
      { header: "Descripcion", value: (item) => item.descripcion },
      { header: "Solicitado", value: (item) => item.solicitado },
      { header: "Existencia", value: (item) => item.existencia },
      { header: "Diferencia", value: (item) => item.diferencia },
    ],
  });
};
